var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9739 11.8049C26.685 14.7534 12.6734 22.0391 6.32213 23.7705C-0.0291429 25.5019 18.6045 16.9648 17.8773 14.0163C17.15 11.0677 2.29804 13.4849 8.64932 11.7534C15.0006 10.022 25.2628 8.85632 25.9739 11.8049Z",
    fill: "url(#paint0_linear_883_4918)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_883_4918",
    x1: 13.6625,
    y1: 10.3803,
    x2: 16.5637,
    y2: 20.9636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACACA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrb);
export default __webpack_public_path__ + "static/media/TRB.ca9ad79ba9ca095a0036c16c5212002a.svg";
export { ForwardRef as ReactComponent };